import userProfileMenu from './user-profile-menu.json';
import userProfileTabs from './user-profile-tabs';

export default {
  'user-profile': {
    ...userProfileMenu,
    ...userProfileTabs,
  },
};
